import { env } from "@/constants";
export const getBaseApiUrl = () => `${env.VITE_API_BASE_URL}`;
export const getApiUrl = (path: string) => `${env.VITE_API_BASE_URL}/${path}`;
